import { useState, useEffect } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import QuoteRequest from '@Components/Quotes/QuoteRequest';

const QuoteRequestListView = (props) => {

    const routes = useRecoilValue(atoms.routes);

    const [rentalQuoteRequests, setRentalQuoteRequests] = useState(props.QuoteRequests ? props.QuoteRequests.reduce((list, raq) => {
        list[raq.EquipmentType] = list[raq.EquipmentType] || [];
        list[raq.EquipmentType].push(raq);
        return list;
    }, {}) : null);

    const deleteRentalQuoteRequest = (id, equipmentType) => {
        sandhillsRequest({
            url: props.DeleteQuoteRoute + '/' + id,
            method: 'post',
            data: {
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then(() => {
            setRentalQuoteRequests((previousState) => {
                let rentalQuoteRequests = { ...previousState };
                rentalQuoteRequests[equipmentType] = rentalQuoteRequests[equipmentType].filter(raq => raq.EquipmentMessageID != id);
                return rentalQuoteRequests;
            });
        });
    };

    return (
        <div>
            <div className='quote-requests'>
                {props.EquipmentTypeOptions?.map((type, i) =>
                    <div key={i}>
                        <div className='wtb-sect-header'>
                            <div className='wtb-half'>
                                <h4>{type}</h4>
                            </div>
                            <div className='wtb-half'>
                                <h4>{(rentalQuoteRequests && rentalQuoteRequests[type] ? rentalQuoteRequests[type].length : '0')}</h4>
                            </div>
                        </div>
                        {rentalQuoteRequests && rentalQuoteRequests[type] ?
                            <div key={type}>
                                {rentalQuoteRequests[type].map(request =>
                                    <QuoteRequest {...request} key={request.EquipmentMessageID} onDelete={() => deleteRentalQuoteRequest(request.EquipmentMessageID, type)} />)}
                            </div>
                            :
                            <div>
                                {props.ShowNewMessages ? 
                                    <div className='wtb-entry'>
                                        <span className='no-wtb'><TranslationText tKey='sandhills.noquoterequests'/></span>
                                    </div> :
                                    <div className='wtb-entry'>
                                        <span className='no-wtb'><TranslationText tKey='sandhills.nonewmessages' /></span>
                                    </div>}
                            </div>}
                    </div>
                )}
            </div>

        </div>
    );
};

export default QuoteRequestListView;